import React, { useEffect, useState } from "react";
import { Table, Form, Pagination } from "react-bootstrap";
import { getLawFirmInformationService } from "../../services/BondsServices";

const LawFirmModal = ({ setLawFirm, onHide }) => {
  const [allFirms, setAllFirms] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredFirms, setFilteredFirms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchFirmData();
  }, []);

  useEffect(() => {
    if (allFirms.length > 0) {
      const filteredFirms = allFirms.filter((firm) =>
        firm.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredFirms(filteredFirms);
      setCurrentPage(1); // Reset to first page on new search
    }
  }, [allFirms, searchTerm]);

  const handleSelectFirm = (firm) => {
    if (selectedFirm.includes(firm)) {
      setSelectedFirm(selectedFirm.filter((u) => u !== firm));
    } else {
      setSelectedFirm([...selectedFirm, firm]);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleAddUser = () => {
    setLawFirm(selectedFirm);
    onHide();
  };

  const fetchFirmData = async () => {
    try {
      const firmResponse = await getLawFirmInformationService();
      setAllFirms(firmResponse);
      setFilteredFirms(firmResponse);
    } catch (error) {
      console.error("Error fetching law firm data:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the index of the first and last items on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredFirms.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredFirms.length / itemsPerPage);

  return (
    <div>
      <div size="auto">
        <h3>Law Firm Table</h3>
        <div>
          <Form.Control
            type="text"
            placeholder="Search by Name"
            value={searchTerm}
            onChange={handleSearch}
          />
          <br></br>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <Table className="modal-table" size="sm">
            <thead>
              <tr>
                <th></th>
                <th>Law Firm</th>
                {/* Add more columns as needed */}
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 &&
                currentItems.map((firm, index) => (
                  <tr key={firm}>
                    <td>
                      <input
                        type="radio"
                        name="selectedFirm"
                        value={firm}
                        checked={selectedFirm === firm}
                        onChange={() => setSelectedFirm(firm)}
                      />
                    </td>
                    <td>{firm}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
        <Pagination>
          <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
        <div className="button-container right">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddUser}
            disabled={selectedFirm.length === 0}
          >
            Select Firm
          </button>
        </div>
      </div>
    </div>
  );
};

export default LawFirmModal;
